import { TempActions } from '@mode/charts/domain';

import { ActiveExplorationActionType } from '~/actions/exploration/active-exploration.actions';

import { ActiveExplorationRoot, ActiveExplorationState } from '@mode/legacy/types-app-state';
import { combineAllReducers, ReducerTree } from '@mode/legacy/util-domain';
import { Actions } from '../actions';

export const initialActiveExplorationState: ActiveExplorationRoot = {
  activeExploration: {
    _resource: null,
    token: null,
    vizToken: null,
    creatorUsername: null,
    creatorName: null,
    creatorAvatar: null,
    updatedAt: null,
    spaceName: null,
    spaceUrl: null,
    isSpaceViewable: false,
    isCollectionCommunity: false,
    isCollectionPersonal: true,
    defaultAccess: null,
    drilldownEnabled: false,
    isLatestReportRun: true,
    isLatestSuccessfulReportRun: true,
    reportHasFailuresSinceLastSuccess: false,
    reportRunFormFields: [],
  },
};

export function explorationTokenReducer(
  state = initialActiveExplorationState.activeExploration.token,
  action: Actions
): ActiveExplorationState['token'] {
  switch (action.type) {
    case TempActions.loadExploration.type: // fallthrough
      return action.explorationToken;
  }

  return state;
}

export function vizTokenReducer(
  state = initialActiveExplorationState.activeExploration.token,
  action: Actions
): ActiveExplorationState['vizToken'] {
  switch (action.type) {
    case TempActions.loadExploration.type: // fallthrough
      return action.explorationViz.token;
  }

  return state;
}

/**
 * GF only reducer
 */
export function switchViewTokenReducer(
  state = initialActiveExplorationState.activeExploration.switchViewToken,
  action: Actions
): ActiveExplorationState['switchViewToken'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.switchViewToken;
  }

  return state;
}

/**
 * GF only reducer
 */
export function sourceReportNameReducer(
  state = initialActiveExplorationState.activeExploration.sourceReportName,
  action: Actions
): ActiveExplorationState['sourceReportName'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.sourceReportName;
  }

  return state;
}

export function explorationResourceReducer(
  state = initialActiveExplorationState.activeExploration._resource,
  action: Actions
): ActiveExplorationState['_resource'] {
  switch (action.type) {
    case ActiveExplorationActionType.UpdateExplorationSuccess:
      return action.resource;
  }

  return state;
}

export function explorationCreatorUsernameReducer(
  state = initialActiveExplorationState.activeExploration.creatorUsername,
  action: Actions
): ActiveExplorationState['creatorUsername'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.creator.username;
  }

  return state;
}

export function explorationCreatorNameReducer(
  state = initialActiveExplorationState.activeExploration.creatorName,
  action: Actions
): ActiveExplorationState['creatorName'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.creator.name;
  }

  return state;
}

export function explorationCreatorAvatarReducer(
  state = initialActiveExplorationState.activeExploration.creatorAvatar,
  action: Actions
): ActiveExplorationState['creatorAvatar'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.creator.avatar;
  }

  return state;
}

export function explorationUpdatedAtReducer(
  state = initialActiveExplorationState.activeExploration.updatedAt,
  action: Actions
): ActiveExplorationState['updatedAt'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.explorationUpdatedAt;
  }

  return state;
}

export function explorationSpaceNameReducer(
  state = initialActiveExplorationState.activeExploration.spaceName,
  action: Actions
): ActiveExplorationState['spaceName'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.spaceName;
  }

  return state;
}

export function explorationSpaceDefaultAccessReducer(
  state = initialActiveExplorationState.activeExploration.defaultAccess,
  action: Actions
): ActiveExplorationState['defaultAccess'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.defaultAccess;
  }

  return state;
}

export function explorationSpaceUrlReducer(
  state = initialActiveExplorationState.activeExploration.spaceUrl,
  action: Actions
): ActiveExplorationState['spaceUrl'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.spaceUrl;
  }

  return state;
}

export function explorationIsSpaceViewableReducer(
  state = initialActiveExplorationState.activeExploration.isSpaceViewable,
  action: Actions
): ActiveExplorationState['isSpaceViewable'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.isSpaceViewable;
  }

  return state;
}

export function explorationIsCollectionCommunityReducer(
  state = initialActiveExplorationState.activeExploration.isCollectionCommunity,
  action: Actions
): ActiveExplorationState['isCollectionCommunity'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.isCollectionCommunity;
  }

  return state;
}

export function explorationIsCollectionPersonalReducer(
  state = initialActiveExplorationState.activeExploration.isCollectionPersonal,
  action: Actions
): ActiveExplorationState['isCollectionPersonal'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.isCollectionPersonal;
  }

  return state;
}

export function explorationDrilldownEnabledReducer(
  state = initialActiveExplorationState.activeExploration.drilldownEnabled,
  action: Actions
): ActiveExplorationState['drilldownEnabled'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.drilldownEnabled;
  }

  return state;
}

export function explorationIsLatestReportRunReducer(
  state = initialActiveExplorationState.activeExploration.isLatestReportRun,
  action: Actions
): ActiveExplorationState['isLatestReportRun'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.isLatestReportRun;
  }

  return state;
}

export function explorationIsLatestSuccessfulReportRunReducer(
  state = initialActiveExplorationState.activeExploration.isLatestSuccessfulReportRun,
  action: Actions
): ActiveExplorationState['isLatestSuccessfulReportRun'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.isLatestSuccessfulReportRun;
  }

  return state;
}

export function explorationReportHasFailuresSinceLastSuccessReducer(
  state = initialActiveExplorationState.activeExploration.reportHasFailuresSinceLastSuccess,
  action: Actions
): ActiveExplorationState['reportHasFailuresSinceLastSuccess'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.reportHasFailuresSinceLastSuccess;
  }

  return state;
}

export function explorationReportRunFormFieldsReducer(
  state = initialActiveExplorationState.activeExploration.reportRunFormFields,
  action: Actions
): ActiveExplorationState['reportRunFormFields'] {
  switch (action.type) {
    case TempActions.loadExploration.type:
      return action.reportRunFormFields;
  }

  return state;
}

export const activeExplorationReducers: ReducerTree<ActiveExplorationRoot, ActiveExplorationState, Actions> = {
  _resource: explorationResourceReducer,
  token: explorationTokenReducer,
  switchViewToken: switchViewTokenReducer,
  sourceReportName: sourceReportNameReducer,
  vizToken: vizTokenReducer,
  creatorUsername: explorationCreatorUsernameReducer,
  creatorName: explorationCreatorNameReducer,
  creatorAvatar: explorationCreatorAvatarReducer,
  updatedAt: explorationUpdatedAtReducer,
  spaceName: explorationSpaceNameReducer,
  spaceUrl: explorationSpaceUrlReducer,
  isSpaceViewable: explorationIsSpaceViewableReducer,
  isCollectionCommunity: explorationIsCollectionCommunityReducer,
  isCollectionPersonal: explorationIsCollectionPersonalReducer,
  defaultAccess: explorationSpaceDefaultAccessReducer,
  drilldownEnabled: explorationDrilldownEnabledReducer,
  isLatestReportRun: explorationIsLatestReportRunReducer,
  isLatestSuccessfulReportRun: explorationIsLatestSuccessfulReportRunReducer,
  reportHasFailuresSinceLastSuccess: explorationReportHasFailuresSinceLastSuccessReducer,
  reportRunFormFields: explorationReportRunFormFieldsReducer,
};

export const activeExplorationFeatureReducer = combineAllReducers<
  ActiveExplorationRoot,
  keyof ActiveExplorationRoot,
  Actions
>({
  activeExploration: activeExplorationReducers,
});
